import Axios, { AxiosError, AxiosResponse } from "axios";
import { ReportListingReq } from "../types/Report";

const testBaseUrl = process.env.REACT_APP_BASE_URL || "";

export const reportProperty = (req: ReportListingReq, token: string) => {
  const willReportListing = new Promise<any>((resolve) => {
    Axios.post(testBaseUrl + "/api/Reports/ReportProperty", req, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response: AxiosResponse<any>) => {
        resolve({ data: response.data });
      })
      .catch((err: AxiosError | any) => {
        resolve({ error: err });
      });
  }); 
  return willReportListing;
};


